import { CommonContractorCreateUpdateApp } from '../../../../Dashboard/Contractors/Functionality/ContractorCreateUpdateFlows/CommonContractorCreateUpdateApp';
import { permissionObj } from '../../../../../Helpers/permission';
import routes from '../../../../../Routes/routes';
import HeadTittle from '../../../../../components/HeadTittle';
import React from 'react';
import { EmployeeFlowSupplierCreateApp } from '../../Funtionality/SupplierCreateUpdateFlows/EmployeeFlowSupplierCreateApp';
import CopySecretModal from '../../../../Dashboard/Company/Employees/Modal/CopySecretModal';
import EmployeeFlowSupplierCreateWithExtraData from './EmployeeFlowSupplierCreateWithExtraData';
import EmployeeFlowSupplierCreateWithoutExtraData from './EmployeeFlowSupplierCreateWithoutExtraData';
import { TABS_PROVIDER } from '../../../Model/Model';

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
const EmployeeFlowSupplierCreate = () => {
    const props = CommonContractorCreateUpdateApp();

    const {
        t,
        dispatch,
        navigate,
        DEV,
        permission,
        isValidEmail,
        isValidPassword,
        isValidPhoneNumber,
        isValidDob,
        setIsValidDob,
        isValidDocumentId,
        setIsValidDocumentId,
        userInfoStatusList,
        emptyFields,
        setEmptyFields,
        setIsValidEmail,
        setIsValidPhoneNumber,
        handleDateChange,
        handleEmailChange,
        handlePhoneNumberChange,
        validateEmail,
        validatePhone,
        handlePasswordChange,
        secretModal,
        setSecretModal,
        secretKey,
        setSecretKey,
        generatedPassword,
        setGeneratedPassword,
        passwordGenerator,
        disabled,
        activeStep,
        setActiveStep,
        steps,
        setSteps,
        handleStepChange,
        photoPicker,
        setPhotoPicker,
        extraData,
        extraDataEnabled,
        setExtraData,
        setExtraDataEnabled,
        headersList,
    } = props;

    const {
        user,
        setUser,
        FormHandler,
        resetForm,
        getAllServiceType,
        handleValidateSteps,
        handleOnBack,
        handleChange,
        handleClearExtraData,
    } = EmployeeFlowSupplierCreateApp({
        t,
        dispatch,
        navigate,
        emptyFields,
        setEmptyFields,
        isValidDob,
        photoPicker,
        setPhotoPicker,
        permission,
        setIsValidEmail,
        setIsValidPhoneNumber,
        isValidPassword,
        setSecretModal,
        setSecretKey,
        setGeneratedPassword,
        passwordGenerator,
        setSteps,
        isValidDocumentId,
        setIsValidDocumentId,
        extraData,
        extraDataEnabled,
        setExtraData,
        setExtraDataEnabled,
        headersList,
    });

    if (
        !DEV &&
        (!permission?.includes(permissionObj.WEB_SUPPLIER_READ) ||
            !permission?.includes(permissionObj.WEB_SUPPLIER_CREATE))
    )
        navigate(routes.forbidden);

    return (
        <>
            <HeadTittle onBack={handleOnBack} name={t('create')} />
            {extraDataEnabled ? (
                <EmployeeFlowSupplierCreateWithExtraData
                    steps={steps}
                    activeStep={activeStep}
                    setActiveStep={setActiveStep}
                    handleStepChange={handleStepChange}
                    user={user}
                    setUser={setUser}
                    emptyFields={emptyFields}
                    isValidDocumentId={isValidDocumentId}
                    setIsValidDocumentId={setIsValidDocumentId}
                    isValidEmail={isValidEmail}
                    isValidPhoneNumber={isValidPhoneNumber}
                    isValidDob={isValidDob}
                    setIsValidDob={setIsValidDob}
                    handleEmailChange={handleEmailChange}
                    handlePasswordChange={handlePasswordChange}
                    handlePhoneNumberChange={handlePhoneNumberChange}
                    handleDateChange={handleDateChange}
                    userInfoStatusList={userInfoStatusList}
                    resetForm={resetForm}
                    handleValidateSteps={handleValidateSteps}
                    photoPicker={photoPicker}
                    setPhotoPicker={setPhotoPicker}
                    extraData={extraData}
                    setExtraData={setExtraData}
                    handleChange={handleChange}
                    headersList={headersList}
                    handleClearExtraData={handleClearExtraData}
                    getAllServiceType={getAllServiceType}
                    FormHandler={FormHandler}
                    disabled={disabled}
                    validateEmail={validateEmail}
                    validatePhone={validatePhone}
                />
            ) : (
                <EmployeeFlowSupplierCreateWithoutExtraData
                    steps={steps}
                    activeStep={activeStep}
                    setActiveStep={setActiveStep}
                    handleStepChange={handleStepChange}
                    user={user}
                    setUser={setUser}
                    emptyFields={emptyFields}
                    isValidDocumentId={isValidDocumentId}
                    setIsValidDocumentId={setIsValidDocumentId}
                    isValidEmail={isValidEmail}
                    isValidPhoneNumber={isValidPhoneNumber}
                    isValidDob={isValidDob}
                    setIsValidDob={setIsValidDob}
                    handleEmailChange={handleEmailChange}
                    handlePasswordChange={handlePasswordChange}
                    handlePhoneNumberChange={handlePhoneNumberChange}
                    handleDateChange={handleDateChange}
                    userInfoStatusList={userInfoStatusList}
                    resetForm={resetForm}
                    handleValidateSteps={handleValidateSteps}
                    photoPicker={photoPicker}
                    setPhotoPicker={setPhotoPicker}
                    FormHandler={FormHandler}
                    getAllServiceType={getAllServiceType}
                    disabled={disabled}
                    validateEmail={validateEmail}
                    validatePhone={validatePhone}
                />
            )}
            <CopySecretModal
                show={secretModal}
                setShow={setSecretModal}
                secret={secretKey}
                setSecret={setSecretKey}
                setData={setUser}
                generatedPassword={generatedPassword}
                onHide={() => {
                    navigate(routes.suppliers.main, {
                        state: { currentTab: TABS_PROVIDER.SUPPLIERS.INDEX },
                    });
                }}
                closeText={'continue'}
            />
        </>
    );
};
export default EmployeeFlowSupplierCreate;
